export default {
  reports: 'Raporlar',
  createReport: 'Rapor oluştur',
  selectRiderOrDriver: 'Yolcu ya da sürücü seçin ',
  selectReportType: 'Rapor tipi seçin',
  selectCampus: 'Kampüs seçin',
  noDataFound: 'Seçilen rapor için veri bulunamadı.',
  selectModules: 'Modül seçin',
  noModulesFound: 'Modül bulunamadı',
  threshold: 'Dakika',
  enterThreshold: 'Dakika girin',
  selectCampus: 'Kampüs seçin',
};
